import { render, staticRenderFns } from "./UseBox.vue?vue&type=template&id=0f01e481"
import script from "./UseBox.vue?vue&type=script&lang=js"
export * from "./UseBox.vue?vue&type=script&lang=js"
import style0 from "./UseBox.vue?vue&type=style&index=0&id=0f01e481&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports